import Restaurant from "@components/restaurant/models/Restaurant";
import { isCurrentTimeBetweenTwoTimes } from "./dateTimeFormatter";

export function getIsDeliveryActive(restaurant: Restaurant) {
    if (restaurant.deliveryTimeFrom === null || restaurant.deliveryTimeTo === null || restaurant.hasDelivery === false) {
        return false;
    }

    if (isCurrentTimeBetweenTwoTimes(restaurant.deliveryTimeFrom.substr(0, 5), restaurant.deliveryTimeTo?.substr(0, 5))) {
        return true;
    }
    return false;
};

export function getIsOpenTimeActive(restaurant: Restaurant) {
    if (
        isCurrentTimeBetweenTwoTimes(
            restaurant.openingTime.substr(0, 5),
            restaurant.closingTime.substr(0, 5)
        )
    ) {
        return true;
    }
    return false;
};

export function getRestaurantImageUrl(restaurantId: string){
    return `${process.env.REACT_APP_IMAGES_URL}/${restaurantId}.jpg`;
  }